import styled, { css } from 'styled-components';

interface StyledTableProps {
  is1Dimensional: boolean;
}

export const StyledText = styled.p`
  font-size: var(--cl-font-size-2);
  font-weight: var(--cl-font-weight-regular);
`;

export const StyledTable = styled.table<StyledTableProps>`
  border-spacing: 0;
  border-collapse: separate;

  td, th {
    background-color: white;
    border: 1px solid var(--cl-gray-400);
    font-size: var(--cl-font-size-2);
    font-weight: var(--cl-font-weight-regular);
    padding: var(--cl-space-2) var(--cl-space-4);
    text-align: right;
    white-space: wrap;
    width: 200px;
  }
  
  ${({ is1Dimensional }) => (
    is1Dimensional
      ? css`
          th:first-child, th:nth-child(2) {
            border: none;
            background-color: transparent;
            white-space: nowrap;
            text-align: left;
          }
        `
      : css`
          th:first-child {
            border-top: none;
            border-left: none;
            text-align: left;
            background-color: transparent;
            width: 300px;
          }
        `
  )}
`;
